import React, { Component } from 'react';
import { ScanTote } from './SOPSummary/componentChildren/ScanTote';
import { ViewSO } from './SOPSummary/componentChildren/ViewSO';

import './SOPSummary/css/SOPSummary.css'
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';

export default class SOPSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInput: '',
            showInfo: false,
            orderInfo: {},
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        };
        this.resetState = this.resetState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.lookupOrder = this.lookupOrder.bind(this);
        this.lookupOrderCallback = this.lookupOrderCallback.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        
    }

    resetState() {
        this.setState({
            userInput: '',
            orderInfo: {},
            showInfo: false,
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        });
        
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            isErrorMessage: false
        });
        this.focusOnInput();
    }

    lookupOrder(e) {
        e.preventDefault();
        if (this.state.userInput) {
            this.setState({
                loading: true,
                orderInfo: {},
                showInfo: false,
            });
            this.lookupOrderCallback();
        } else {
            this.focusOnInput();
        }
    }

    async lookupOrderCallback() {
        await this.props.makeRESTCall(
            'byuwmssopsummary?recordNum=' + this.state.userInput,
            'get',
            null,
            (orderInfo) => {
                if (!orderInfo.errMessage) {
                    if (orderInfo.toteMessage) {
                        this.setState({
                            dialogContent: orderInfo.toteMessage,
                            dialogTitle: "Sales Order Tote Info",
                            showDialog: true,
                            isErrorMessage: false,
                            userInput: '',
                            loading: false
                        });
                    }
                    else {
                        this.setState({
                            orderInfo: orderInfo,
                            showInfo: true,
                            loading: false,
                            userInput: ''
                        });
                    }
                }
                else {
                    this.setState({
                        dialogContent: orderInfo.errMessage,
                        dialogTitle: "Unable to look up order",
                        showDialog: true,
                        isErrorMessage: false,
                        userInput: '',
                        loading: false
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
                this.focusOnInput();
            }
        );
    }

    focusOnInput() {
      document.getElementById("scanTote").focus();
    }

    updateInputValue(inputValue) {
        this.setState({
            userInput: inputValue.toUpperCase()
        });
    }

    render() {
        return (
            <div className="SOPSummary">
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                <ScanTote
                    lookupOrder={this.lookupOrder}
                    updateInputValue={this.updateInputValue}
                    userInput={this.state.userInput}
                />
                {
                    this.state.showInfo
                    &&
                    <ViewSO
                        userInput={this.state.userInput}
                        orderInfo={this.state.orderInfo}
                        tote={this.state.userInput}
                        resetState={this.resetState}
                    />
                }
            </div>
        );
    }
}
